import { memo } from 'react';

import { PlayerPlayButton, PlayerPlaybackRateButton, PlayerVolumeButton } from '@air/component-player';

export type AssetModalFooterVideoControlsProps = {
  hidePlaybackRate?: boolean;
};

export const AssetModalFooterVideoControls = memo(
  ({ hidePlaybackRate = false }: AssetModalFooterVideoControlsProps) => {
    return (
      <div className="flex items-center gap-2">
        <PlayerPlayButton />
        <PlayerVolumeButton />
        {!hidePlaybackRate && <PlayerPlaybackRateButton />}
      </div>
    );
  },
);

AssetModalFooterVideoControls.displayName = 'AssetModalFooterVideoControls';
